import { render, staticRenderFns } from "./PageLayout.vue?vue&type=template&id=6ade0bd9&scoped=true&"
import script from "./PageLayout.vue?vue&type=script&lang=js&"
export * from "./PageLayout.vue?vue&type=script&lang=js&"
import style0 from "./PageLayout.vue?vue&type=style&index=0&id=6ade0bd9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ade0bd9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ade0bd9')) {
      api.createRecord('6ade0bd9', component.options)
    } else {
      api.reload('6ade0bd9', component.options)
    }
    module.hot.accept("./PageLayout.vue?vue&type=template&id=6ade0bd9&scoped=true&", function () {
      api.rerender('6ade0bd9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/PageLayout.vue"
export default component.exports